import { useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
///////////////////////////////////
function Logout(props) {
    const navigate = useNavigate();
    const users = window.getFromStorage("user-info");
    useEffect(() => {
        if (users !== "null") {
            const user = JSON.parse(users);
            clearCacheUser(user); ///xoa cache nguoi dung o phia server
        } else navigate("/login");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    async function clearCacheUser(user) {
        window.localStorage.clear(); ///xóa toàn bộ trong localStorage
        const result = await fetch(global.config.url.api + "login/clearCache", {
            method: "GET",
            headers: {
                "user-id": user.id,
            },
        });
        const results = await result.json();
        if (results.code == 200) {
            //const user = JSON.parse(users);
            if (user.token_sso_ag) {
                logout_sso(user);
            } else {
                navigate("/login");
            }
            navigate("/login");
        }
    }
    const logout_sso = async (user) => {
        const auth_sso_ag = JSON.parse(user.auth_sso_ag);
        const token_sso_ag = user.token_sso_ag;
        const data = {
            //client_id: global.config.sso_ag.client_key,
            session_state: auth_sso_ag.session_state,
            id_token_hint: token_sso_ag.id_token,
            post_logout_redirect_uri: global.config.url.api + "login/callbackAG",
        };
        //console.log(data);
        window.location = "https://sso.angiang.gov.vn/oidc/logout?" + window.objectToQueryString(data);
    };
}
export default memo(Logout);
